export const ROLES = {
  USER: 'USER',
  ADMIN: 'ADMIN',
  SUPERADMIN: 'SUPERADMIN',
  TESTER: 'TESTER',
};

export const DEPARTMENTS = {
  FINANCE: 'FINANCE',
  HR: 'HR',
  PROCUREMENT: 'PROCUREMENT',
  PAYROLL: 'PAYROLL',
  IT: 'IT',
  SALES: 'SALES',
  Engineering: 'Engineering',
  Tech: 'Tech',
  Manger: 'Manger',
  TEST: 'TEST',
};

function normalizeRole(role) {
  if (!role) return '';
  return String(role).toUpperCase().replace(/^ROLE_/, '').replace('_', '');
}

export function isSuperadmin(user) {
  const r = normalizeRole(user?.role);
  return r === ROLES.SUPERADMIN || r === ROLES.TESTER || String(user?.username || '').toLowerCase() === 'superadmin';
}

export function isAdmin(user) {
  const r = normalizeRole(user?.role);
  return r === ROLES.ADMIN || r === ROLES.SUPERADMIN || r === ROLES.TESTER;
}

export function hasRole(user, roles) {
  if (!user) return false;
  if (!roles || roles.length === 0) return true;
  const userRole = normalizeRole(user.role);
  if (userRole === ROLES.TESTER || userRole === ROLES.SUPERADMIN) return true;
  const list = Array.isArray(roles) ? roles : [roles];
  return list.map(normalizeRole).includes(userRole);
}

export function hasDept(user, depts) {
  if (!user) return false;
  if (isSuperadmin(user)) return true;
  if (!depts || depts.length === 0) return true;
  const list = (Array.isArray(depts) ? depts : [depts]).map((d) =>
    String(d).toUpperCase(),
  );
  const userDepts = (user.depts || []).map((d) => String(d).toUpperCase());
  return list.some((d) => userDepts.includes(d));
}

/**
 * Higher-level capability check used by sidebar / route guards.
 * requires = { roles?: string[], depts?: string[], anyOf?: requires[] }
 */
export function can(user, requires) {
  if (!user) return false;
  if (!requires) return true;
  if (isSuperadmin(user)) return true;
  if (Array.isArray(requires.anyOf)) {
    return requires.anyOf.some((r) => can(user, r));
  }
  if (requires.roles && !hasRole(user, requires.roles)) return false;
  if (requires.depts && !hasDept(user, requires.depts)) return false;
  return true;
}

export { normalizeRole };
